import { useMemo } from 'react';
import { useAgendaConfig } from '@/hooks/useAgendaConfig';
import { useAuth } from '@/contexts/AuthContext';
import { addDays, isSameDay, format, startOfDay, endOfDay } from 'date-fns';

export const useSmartDateSelection = () => {
  const { user } = useAuth();
  const { config: agendaConfig } = useAgendaConfig();

  return useMemo(() => {
    if (!user || !agendaConfig) {
      return new Date();
    }

    const today = new Date();
    const now = new Date();
    const workingDays = agendaConfig.working_days || ['mon', 'tue', 'wed', 'thu', 'fri'];
    
    // Check if today is a working day
    const todayDayName = today.toLocaleDateString('en-US', { weekday: 'short' }).toLowerCase();
    const isTodayWorking = workingDays.includes(todayDayName);
    
    if (!isTodayWorking) {
      // If today is not a working day, find the next working day
      let nextWorkingDay = today;
      let attempts = 0;
      const maxAttempts = 7; // Prevent infinite loop
      
      while (attempts < maxAttempts) {
        nextWorkingDay = addDays(nextWorkingDay, 1);
        const dayName = nextWorkingDay.toLocaleDateString('en-US', { weekday: 'short' }).toLowerCase();
        
        if (workingDays.includes(dayName)) {
          return nextWorkingDay;
        }
        
        attempts++;
      }
    }
    
    // If today is a working day, check if there are still available slots
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentTimeString = `${currentHour.toString().padStart(2, '0')}:${currentMinute.toString().padStart(2, '0')}`;
    

    
    // Check if current time is past the close time or very close to it
    if (agendaConfig.close_time && currentTimeString >= agendaConfig.close_time) {
      // Find next working day
      let nextWorkingDay = today;
      let attempts = 0;
      const maxAttempts = 7;
      
      while (attempts < maxAttempts) {
        nextWorkingDay = addDays(nextWorkingDay, 1);
        const dayName = nextWorkingDay.toLocaleDateString('en-US', { weekday: 'short' }).toLowerCase();
        
        if (workingDays.includes(dayName)) {
          return nextWorkingDay;
        }
        
        attempts++;
      }
    }
    
    // If we're still within working hours today, return today
    return today;
  }, [user, agendaConfig]);
};
